import styled from 'styled-components';

export const TrendingChartWrapper = styled.div`
 display: flex;
 .phychart{
     width: 100%;
     height: 600px;
     overflow: hidden;
     overflow-y: scroll;
 }
`;
